/**
 * Hub Medical
 * Hub medical Consorcio
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Profession { 
    id?: number;
    councilGroup?: Profession.CouncilGroupEnum;
    professionName?: string;
    specialty?: string;
    activityArea?: string;
    active?: boolean;
}
export namespace Profession {
    export type CouncilGroupEnum = 'CRM' | 'COREN' | 'CRO' | 'CRF' | 'CREFITO' | 'CRP' | 'CRBM' | 'CRN' | 'CREF' | 'CREFONO' | 'CRESS' | 'CRMV' | 'CRTR' | 'CRQ' | 'CRBIO';
    export const CouncilGroupEnum = {
        Crm: 'CRM' as CouncilGroupEnum,
        Coren: 'COREN' as CouncilGroupEnum,
        Cro: 'CRO' as CouncilGroupEnum,
        Crf: 'CRF' as CouncilGroupEnum,
        Crefito: 'CREFITO' as CouncilGroupEnum,
        Crp: 'CRP' as CouncilGroupEnum,
        Crbm: 'CRBM' as CouncilGroupEnum,
        Crn: 'CRN' as CouncilGroupEnum,
        Cref: 'CREF' as CouncilGroupEnum,
        Crefono: 'CREFONO' as CouncilGroupEnum,
        Cress: 'CRESS' as CouncilGroupEnum,
        Crmv: 'CRMV' as CouncilGroupEnum,
        Crtr: 'CRTR' as CouncilGroupEnum,
        Crq: 'CRQ' as CouncilGroupEnum,
        Crbio: 'CRBIO' as CouncilGroupEnum
    };
}


